// extracted by mini-css-extract-plugin
export default {"buttonContentContainer":"DiscardOrder_buttonContentContainer__6kWq7","flexContainer":"DiscardOrder_flexContainer__bzMp2"};